export default {
  fr: { title: 'Pourquoi on aime ?' },
  en: { title: 'Why we love it?' },
  'pt-br': { title: 'Por que adoramos?' },
  es: { title: '¿Por qué nos encanta?' },
  de: { title: 'Warum wir es lieben?' },
} as const
